module.exports = __webpack_public_path__ + "static/media/git-pull-request.ee516a62.svg";